import { Outlet } from "react-router-dom";
import { AdminHeader } from "@/components/admin/AdminHeader";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminLayout() {
    const navigate = useNavigate();

    // Check for return path from Stripe flow (stored in sessionStorage)
    useEffect(() => {
        const returnTo = sessionStorage.getItem("rk_return_to");
        const urlParams = new URLSearchParams(window.location.search);
        const billingStatus = urlParams.get("billing"); // success or cancel?

        // If we have a stored return path AND we are on a default landing (like dashboard) 
        // OR we just came back from billing (indicated by param although param might be on dashboard)
        // Actually, if we are just loading the app, we check.
        // But validation: we only redirect if we are NOT already there.
        // And we clear it.

        if (returnTo) {
            // Only redirect if current path is NOT the return path
            // normalize paths
            const currentPath = window.location.pathname + window.location.search;
            if (currentPath !== returnTo && billingStatus) {
                // If billing param is present, it means we likely just came back.
                // We redirect to the returnTo path (which might include the billing param if we added it, but likely not).
                // We should append the billing param to the return path if it's not there, so the toast triggers?
                // Or just let the page handle it.
                // User says: "If the URL includes `returnTo`... Else if sessionStorage... navigate there".

                // Simplest: If sessionStorage exists, consume it.
                sessionStorage.removeItem("rk_return_to");
                navigate(returnTo);
            }
        }
    }, [navigate]);

    return (
        <div className="min-h-screen bg-background">
            <AdminHeader />
            <Outlet />
        </div>
    );
}
